<script>import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const WalletGameIcon = getIcon("WalletGameIcon");
</script>

{#if typeof WalletGameIcon === 'string'}
	<img src={WalletGameIcon} alt={$t(Verbiage.wallet_icon_alt, 'alts')} />
{:else if typeof WalletGameIcon === 'function'}
	<svelte:component this={WalletGameIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
